// API Configuration
// In production, use the Worker URL. In development, use the local proxy.

const isDevelopment = import.meta.env.DEV;

export const API_BASE_URL = isDevelopment
  ? '' // In dev, Vite proxies /api to the local worker
  : 'https://relo-api.quomx.workers.dev';

export function apiUrl(path: string): string {
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}

// Custom fetch that handles API URL rewriting
export async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  const url = path.startsWith('/api') ? apiUrl(path) : path;
  return fetch(url, init);
}
